export enum CommunicationType {
    Task = 'task',
    Notification = 'notification'
}
